import type { ReactNode } from 'react'
import { textToneClass, type ChipTone } from './tokens'

export type LedgerRowState = 'default' | 'fresh' | 'selected' | 'muted'

export const LedgerRow = ({
  state = 'default',
  current = false,
  unread = false,
  children,
}: {
  state?: LedgerRowState
  current?: boolean
  unread?: boolean
  children: ReactNode
}) => (
  <li className={`ledger-row ledger-row-${state}${current ? ' ledger-row-current' : ''}${unread ? ' ledger-row-unread' : ''}`}>
    {children}
  </li>
)

export const LedgerRowContent = ({
  marker,
  title,
  source,
  time,
  timeTone,
  preview,
  chips,
}: {
  marker?: ReactNode
  title: ReactNode
  source?: ReactNode
  time?: ReactNode
  timeTone?: ChipTone
  preview?: ReactNode
  chips?: ReactNode
}) => (
  <div className="ledger-content">
    {marker === undefined ? null : <div className="ledger-marker">{marker}</div>}
    <span className="ledger-title">{title}</span>
    {source === undefined ? null : <span className="ledger-source num">{source}</span>}
    {time === undefined ? null : (
      <span className={timeTone === undefined ? 'ledger-time num' : `ledger-time num ${textToneClass(timeTone)}`}>{time}</span>
    )}
    {preview === undefined ? null : <p className="ledger-preview">{preview}</p>}
    {chips === undefined ? null : <span className="ledger-chips">{chips}</span>}
  </div>
)
